import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export type CaseFormState = {
  checkedColumnKeys: string[];
  sortedColumnKeys: string[];
};

const initialState: CaseFormState = {
  checkedColumnKeys: [],
  sortedColumnKeys: [],
};

const caseForm = createSlice({
  name: 'case-form',
  initialState,
  reducers: {
    setCheckedColumnKeys(state, action: PayloadAction<CaseFormState['checkedColumnKeys']>) {
      state.checkedColumnKeys = action.payload || initialState.checkedColumnKeys;
    },
    setSortedColumnKeys(state, action: PayloadAction<CaseFormState['sortedColumnKeys']>) {
      state.sortedColumnKeys = action.payload || initialState.sortedColumnKeys;
    },
  },
});

export const { setCheckedColumnKeys, setSortedColumnKeys } = caseForm.actions;
export default caseForm.reducer;
